export default {"src":"/_next/static/media/bg.daf91204.svg","height":800,"width":1600,"blurWidth":0,"blurHeight":0};